import React, { FC, ReactNode, useMemo, useCallback } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork, WalletError } from '@solana/wallet-adapter-base';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';

// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');

export const WalletContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    const network = WalletAdapterNetwork.Devnet;

    // You can also provide a custom RPC endpoint.
    const endpoint = useMemo(() => clusterApiUrl(network), [network]);

    // Phantom and Solflare are automatically detected as Standard Wallets
    // Only add non-Standard Wallet adapters here if needed
    const wallets = useMemo(
        () => [],
        []
    );

    // Handle wallet errors with user-friendly messages
    const onError = useCallback((error: WalletError) => {
        console.error('Wallet error:', error);
        // Don't show alert for user-rejected errors
        if (error.name === 'WalletConnectionError') {
            // Most connection errors are user-side issues
            console.warn('Wallet connection failed. User may need to: unlock wallet, update extension, or try refreshing.');
        }
    }, []);

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect onError={onError}>
                <WalletModalProvider>
                    {children}
                </WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};

